import cx from 'classnames'

type Props = {
  text: string | JSX.Element
  variant?:
    | 'success'
    | 'warning'
    | 'danger'
    | 'info'
    | 'neutral'
    | 'optimize'
    | 'personalize'
  size?: 'small' | 'normal'
  className?: string
}

const Badge = ({
  className,
  text,
  size = 'normal',
  variant = 'neutral',
}: Props) => {
  return (
    <span
      className={cx(
        'rounded whitespace-nowrap font-bold',
        {
          'text-xs py-0.5 px-1': size === 'small',
          'text-sm py-1 px-2': size === 'normal',
          'bg-green-500 text-green-50': variant === 'success',
          'bg-amber-500 text-amber-50': variant === 'warning',
          'bg-red-500 text-red-50': variant === 'danger',
          'bg-blue-500 text-blue-50': variant === 'info',
          'bg-coolGray-500 text-coolGray-50': variant === 'neutral',
          'bg-violet-200 text-violet-800': variant === 'optimize',
          'bg-cyan-200 text-cyan-800': variant === 'personalize',
        },
        className
      )}
    >
      {text}
    </span>
  )
}

export default Badge
